export default __webpack_public_path__ + "static/media/money-bag.9cfcc419.png";